import React from "react";

export default function Html() {
  return (
    <div>
      <svg
        width="60"
        height="60"
        viewBox="0 0 89 102"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.10292 91.7996L0 0H89L80.887 91.8064L44.4783 102L8.10292 91.7996Z"
          fill="#E34E26"
        />
        <path
          d="M44.4997 7.50391V94.203L73.9407 85.9608L80.8768 7.50391H44.4997Z"
          fill="#EF662A"
        />
        <path
          d="M16.5792 18.7637L19.5842 52.8116H58.223L56.9263 67.4156L44.4857 70.8123L32.0681 67.4202L31.2381 58.0432H20.0481L21.6479 76.1195L44.4829 82.5245L67.3465 76.1195L70.4116 41.5543H29.7801L28.76 30.0238H71.3878H71.4221L72.4202 18.7637H16.5792Z"
          fill="white"
        />
        <path
          d="M44.4997 18.7637H16.5792L19.5842 52.8116H44.4997V41.5543H29.7801L28.76 30.0238H44.4997V18.7637Z"
          fill="#EBEBEB"
        />
        <path
          d="M44.4998 70.8075L44.4857 70.8121L32.0681 67.4199L31.2382 58.043H20.0482L21.6479 76.1193L44.4829 82.5243L44.4998 82.5197V70.8075Z"
          fill="#EBEBEB"
        />
      </svg>
    </div>
  );
}
